export default "__VITE_ASSET__BWG5Fvwj__"